export default "/images/vendor/flag-icon-css/flags/4x3/it.svg?290f2fec799fabdf2a85be3d2a2f9977";